<template>
  <modal
    class="affiliate-confirm-modal"
    name="affiliate-confirm-modal"
    height="auto"
    :adaptive="true"
    :scrollable="true"
    @before-close="beforeClose"
  >
    <div class="p-3">
      <div class="form-group">
        <div class="text-xl font-weight-bold">Daten Bestätigen</div>
        Damit wir dir Partnervorschläge aus deiner Nähe und in deiner
        Altersklasse vorschlagen können, brauchen wir natürlich deine korrekten
        Daten. Prüfe diese bitte nun kurz nochmal. Falls etwas nicht korrekt
        ist, kannst du dies nun ändern.
      </div>
      <div class="form-group">
        <div class="text-xl font-weight-bold">Wohnort:</div>
        <autocomplete
          url="/api/v1/register/validate-step/1/autocomplete"
          requestType="get"
          property="location"
          :threshold="2"
          @input="checkPostcode"
          @selected="updatePostcode"
        ></autocomplete>
        <div v-if="errors.zipcode || errors.country_iso3166" class="row">
          <div class="col-12">
            <div class="alert alert-danger" role="alert">
              <span v-for="(error, index) in errors.zipcode" :key="index">{{
                error
              }}</span>
              <span
                v-for="(error, index) in errors.country_iso3166"
                :key="index"
                >{{ error }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column form-group">
        <span class="text-xl font-weight-bold">Geburtstag:</span>
        <div class="row">
          <div class="col-3 pr-1">
            <select
              class="form-control"
              v-model="birthday.day"
              @change="updateBirthday"
            >
              <option
                v-for="(option, index) in birthday.dayRange"
                :key="index"
                >{{ option }}</option
              >
            </select>
          </div>
          <div class="col-3 pl-1 pr-1">
            <select
              class="form-control"
              v-model="birthday.month"
              @change="updateBirthday"
            >
              <option
                v-for="(option, index) in birthday.monthRange"
                :key="index"
                >{{ option }}</option
              >
            </select>
          </div>
          <div class="col-4 pl-1">
            <select
              class="form-control year-selector"
              v-model="birthday.year"
              @change="updateBirthday"
            >
              <option
                v-for="(option, index) in birthday.yearRange"
                :key="index"
                >{{ option }}</option
              >
            </select>
          </div>
        </div>
        <div v-if="errors.birthday" class="row">
          <div class="col-12">
            <div class="alert alert-danger" role="alert">
              <span v-for="(error, index) in errors.birthday" :key="index">{{
                error
              }}</span>
            </div>
          </div>
        </div>
      </div>

      <v-button
        :disabled="!canSave"
        type="submit"
        class="btn-primary btn"
        :working="working"
        @click="save"
        >Speichern</v-button
      >
    </div>
  </modal>
</template>

<script>
import Autocomplete from "autocomplete-vue";
import { range } from "lodash";

export default {
  components: {
    Autocomplete
  },
  data() {
    return {
      working: false,
      lastPostcode: "",
      customer: {
        country_iso3166: null,
        zipcode: null,
        birthday: null
      },
      birthday: {
        day: null,
        dayRange: range(1, 32),
        month: null,
        monthRange: range(1, 13),
        year: null,
        yearRange: range(
          new Date().getFullYear() - 125,
          new Date().getFullYear() - 17
        )
      },
      canClose: false,
      errors: {}
    };
  },
  created() {
    this.$nextTick(() => {
      this.$modal.show("affiliate-confirm-modal");
    });
  },
  methods: {
    checkPostcode(event) {
      if (event != this.lastPostcode) {
        this.customer.country_iso3166 = null;
        this.customer.zipcode = null;
      }
    },
    updatePostcode(event) {
      this.lastPostcode = event;
      let postcode = event;
      if (postcode.includes("(")) {
        let countryAndCity = postcode.split("(")[1];

        let country = countryAndCity
          ? this.mapCountryToCode(
              countryAndCity.substring(0, countryAndCity.indexOf(","))
            )
          : null;

        this.customer.country_iso3166 = country;
        this.customer.zipcode = postcode.split(" ")[0];
      }
    },
    updateBirthday() {
      if (this.birthday.year && this.birthday.month && this.birthday.day) {
        this.customer.birthday = `${this.birthday.year}-${this.birthday.month}-${this.birthday.day}`;
      }
    },
    mapCountryToCode(country) {
      if (country === "DE") {
        return 0;
      } else if (country === "CH") {
        return 1;
      } else {
        return 2;
      }
    },
    beforeClose(event) {
      if (!this.canClose) {
        event.stop();
      }
    },
    save() {
      this.working = true;
      let url = Laravel.user.customer_profile.update_url;
      this.$store
        .dispatch("customerProfile/update", {
          url,
          data: this.customer
        })
        .then(() => {
          this.$notify({
            title: "Daten Gespeichert",
            type: "success"
          });
          this.canClose = true;
          this.$modal.hide("affiliate-confirm-modal");
        })
        .catch(({ response }) => {
          this.working = false;
          this.errors = response.data.errors;
          console.log(response);
        });
    }
  },
  computed: {
    canSave() {
      return (
        this.customer.birthday !== null &&
        this.customer.zipcode !== null &&
        this.customer.country_iso3166 !== null
      );
    }
  }
};
</script>
